import React from 'react';
import { Navigate } from 'react-router';
import { Link } from 'react-router-dom';
import Base from './Base'

export class NavMenu extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            menuOpen: 1,
            menus: {
                menu1: 0,
                menu2: 0,
                menu3:0
            }
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/common/get")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : this.renderForm();

        return contents;
    }
    actionmenu(name) {
        this.state.menus[name] = this.state.menus[name] == 1 ? 0 : 1;
        this.setState({ menus: this.state.menus });
    }
    toggleMenu() {
        if (this.state.menuOpen == 1) this.setState({ menuOpen: 0 });
        else this.setState({ menuOpen: 1 });
    }
    renderForm() {
        return <div className={"nk-sidebar nk-sidebar-fixed " + (this.state.menuOpen == 1 ? "" : "is-compact")} id="sideBarMenu" data-content="sidebarMenu" style={{ backgroundColor:"#16498a" }}>
            <div className="nk-sidebar-element nk-sidebar-head">
                <div className="nk-menu-trigger" onClick={e => this.toggleMenu()}>
                    <a className="nk-nav-toggle nk-quick-nav-icon d-xl-none text-white" data-target="sidebarMenu"><em className="icon ni ni-arrow-left"></em></a>
                    <a className="nk-nav-compact nk-quick-nav-icon d-none d-xl-inline-flex text-white" data-target="sidebarMenu"><em className="icon ni ni-menu"></em></a>
                </div>
                <div className="nk-sidebar-brand">
                    <a href="/" className="logo-link nk-sidebar-logo">
                        <img className="logo-light logo-img" src="/assets/images/sepehrlogowhite.png" alt="" style={{"min-height": "75px"}} />
                        <img className="logo-dark logo-img" src="/assets/images/sepehrlogowhite.png" alt="" style={{ "min-height": "75px" }} />
                    </a>
                </div>

         
            </div>
            <div className="nk-sidebar-element">
                <div className="nk-sidebar-content">
                    <div className="nk-sidebar-menu" data-simplebar="init"><div className="simplebar-wrapper" style={{ margin: '-16px 0px -40px' }} ><div className="simplebar-height-auto-observer-wrapper"><div className="simplebar-height-auto-observer"></div></div><div className="simplebar-mask"><div className="simplebar-offset" style={{ left: '0px', bottom: '0px' }} ><div className="simplebar-content-wrapper" tabindex="0" role="region" aria-label="scrollable content" style={{ height: '100%', overflow: 'hidden scroll' }} ><div className="simplebar-content" style={{ padding: '16px 0px 40px' }}>
                        <ul className="nk-menu">
                            {this.state.data.global.user.role === 1 && <li className="nk-menu-heading">
                                <h6 className="overline-title text-white">مدیریت</h6>
                            </li>}
                            {this.state.data.global.user.role === 1 && <li className="nk-menu-item">
                                <Link to="/users/" className="nk-menu-link">
                                    <span className="nk-menu-icon text-white"><em className="icon ni ni-users"></em></span>
                                    <span className="nk-menu-text text-white">کاربران</span>
                                </Link>
                            </li>}
                            {this.state.data.global.user.role === 1 && <li className="nk-menu-item">
                                <Link to="/units/" className="nk-menu-link">
                                    <span className="nk-menu-icon text-white"><em className="icon ni ni-coins"></em></span>
                                    <span className="nk-menu-text text-white">واحدهای اندازه گیری</span>
                                </Link>
                            </li>}
                            {this.state.data.global.user.role === 1 && <li className="nk-menu-item">
                                <Link to="/plans/" className="nk-menu-link">
                                    <span className="nk-menu-icon text-white"><em className="icon ni ni-box"></em></span>
                                    <span className="nk-menu-text text-white">پلنها</span>
                                </Link>
                            </li>}
                            {this.state.data.global.user.role === 1 && <li className="nk-menu-item">
                                <Link to="/transactions/" className="nk-menu-link">
                                    <span className="nk-menu-icon text-white"><em className="icon ni ni-coins"></em></span>
                                    <span className="nk-menu-text text-white">پرداختها</span>
                                </Link>
                            </li>}
                            {this.state.data.global.user.role === 1 && <li className="nk-menu-item">
                                <Link to="/basestuffs/" className="nk-menu-link">
                                    <span className="nk-menu-icon text-white"><em className="icon ni ni-coins"></em></span>
                                    <span className="nk-menu-text text-white">بانک کالاها/خدمات</span>
                                </Link>
                            </li>}
                            {this.state.data.global.user.role === 1 && <li className="nk-menu-item">
                                <Link to="/settings/" className="nk-menu-link">
                                    <span className="nk-menu-icon text-white"><em className="icon ni ni-setting"></em></span>
                                    <span className="nk-menu-text text-white">تنظیمات</span>
                                </Link>
                            </li>}
                            <li className="nk-menu-item current-page">
                                <a href="/" className="nk-menu-link">
                                    <span className="nk-menu-icon text-white"><em className="icon ni ni-dashboard-fill"></em></span>
                                    <span className="nk-menu-text text-white" text-white>داشبورد</span>
                                </a>
                            </li>

                            <li className={"nk-menu-item has-sub" + (this.state.menus.menu1 === 1 ? " active" : "")}>
                                <a  onClick={e => this.actionmenu("menu1")} className="nk-menu-link nk-menu-toggle">
                                    <span className="nk-menu-icon text-white"><em className="icon ni ni-book-fill"></em></span>
                                    <span className="nk-menu-text text-white">حقوق و دستمزد</span>
                                </a>
                                <ul className="nk-menu-sub" style={{ display: (this.state.menus.menu1 === 1 ? " block" : "none") }} >
                                    <li className="nk-menu-item">
                                        <Link to="/homesalary/" className="nk-menu-link "><span className="nk-menu-text text-white">داشبورد</span></Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/companies/" className="nk-menu-link"><span className="nk-menu-text text-white">کارگا ها</span></Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/configCompany/" className="nk-menu-link"><span className="nk-menu-text text-white">تنظیمات</span></Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/persennels/" className="nk-menu-link"><span className="nk-menu-text text-white">پرسنلی</span></Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/contratos/" className="nk-menu-link"><span className="nk-menu-text text-white">لیست قراردادها</span></Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/workings/" className="nk-menu-link"><span className="nk-menu-text text-white">کارکردها</span></Link>
                                    </li>
                  
                                </ul>

                            </li>
                            <li className={"nk-menu-item has-sub" + (this.state.menus.menu2 === 1 ? " active" : "")}>
                                <a  onClick={e => this.actionmenu("menu2")} className="nk-menu-link nk-menu-toggle">
                                    <span className="nk-menu-icon text-white"><em className="icon ni ni-layers-fill"></em></span>
                                    <span className="nk-menu-text text-white">سامانه مودیان</span>
                                </a>
                                <ul className="nk-menu-sub" style={{ display: (this.state.menus.menu2 === 1 ? " block" : "none") }} >
                                    <li className="nk-menu-item">
                                        <Link to="/hometax/" className="nk-menu-link"><span className="nk-menu-text text-white">داشبورد</span></Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/companiestax/" className="nk-menu-link"><span className="nk-menu-text text-white">مدیریت مودی</span></Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/persons/" className="nk-menu-link"><span className="nk-menu-text text-white">خریداران</span></Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/stuffs/" className="nk-menu-link"><span className="nk-menu-text text-white">کالاها/خدمات</span></Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/cardreaders/" className="nk-menu-link"><span className="nk-menu-text text-white">دستگاه پوز</span></Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/csr/" className="nk-menu-link"><span className="nk-menu-text text-white">ساخت کلید و گواهی</span></Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/invoices/" className="nk-menu-link"><span className="nk-menu-text text-white">صدور صورتحساب</span></Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/reports/" className="nk-menu-link"><span className="nk-menu-text text-white">گزارش صورت حساب</span></Link>
                                    </li>
                                </ul>

                            </li>
                        

                            <li className="nk-menu-item">
                                <a href="#" className="nk-menu-link">
                                    <span className="nk-menu-icon text-white"><em className="icon ni ni-users-fill"></em></span>
                                    <span className="nk-menu-text text-white">CRM</span>
                                </a>
                            </li>
                            <li className="nk-menu-item">
                                <a href="#" className="nk-menu-link">
                                    <span className="nk-menu-icon text-white"><em class="icon ni ni-cart-fill"></em></span>
                                    <span className="nk-menu-text text-white">انبارداری</span>
                                </a>
                            </li>
                            <li className="nk-menu-item">
                                <a href="#" className="nk-menu-link">
                                    <span className="nk-menu-icon text-white"><em class="icon ni ni-book-read"></em></span>
                                    <span className="nk-menu-text text-white">حسابداری</span>
                                </a>
                            </li>
                            <li className="nk-menu-item">
                                <a href="#" className="nk-menu-link">
                                    <span className="nk-menu-icon text-white"><em class="icon ni ni-clipboad-check"></em></span>
                                    <span className="nk-menu-text text-white">خزانه داری</span>
                                </a>
                            </li>
                            <li className="nk-menu-item">
                                <a href="#" className="nk-menu-link">
                                    <span className="nk-menu-icon text-white"><em class="icon ni ni-sign-thb-alt"></em></span>
                                    <span className="nk-menu-text text-white">بهای تمام شده</span>
                                </a>
                            </li>
                            <li className="nk-menu-heading">
                                <h6 className="overline-title text-primary-alt">ابزارها</h6>
                            </li>
                            <li className="nk-menu-item">
                                <Link to="/myplans/" className="nk-menu-link">
                                    <span className="nk-menu-icon text-white"><em className="icon ni ni-coins"></em></span>
                                    <span className="nk-menu-text text-white">پلنهای من</span>
                                </Link>
                            </li>
                            <li className="nk-menu-item">
                                <Link to="/mytransactions/" className="nk-menu-link">
                                    <span className="nk-menu-icon text-white"><em className="icon ni ni-coins"></em></span>
                                    <span className="nk-menu-text text-white">پرداختهای من</span>
                                </Link>
                            </li>

                        </ul>

                    </div></div></div></div><div className="simplebar-placeholder" style={{ width: 'auto', height: '689px' }} ></div></div><div className="simplebar-track simplebar-horizontal" style={{ visibility: 'hidden' }} ><div className="simplebar-scrollbar" style={{ width: '0px', display: 'none' }} ></div></div><div className="simplebar-track simplebar-vertical" style={{ visibility: 'visible' }} ><div className="simplebar-scrollbar" style={{ height: '538px', display: 'block', transform: 'translate3d(0px, 0px, 0px)' }} ></div></div></div>

                </div>

            </div>

        </div>
    }
}
